import { create } from "zustand";

export const SocialStore = create((set) => ({
  rendaExclusivaValue: null,
  creditoRuralValue: null,
  possuiEmpresaValue: null,

  rendaExclusivaImage: null,
  creditoRuralImage: null,
  possuiEmpresaImage: null,

  setRendaExclusivaValue: (val) => set({ rendaExclusivaValue: val }),

  setCreditoRuralValue: (val) => set({ creditoRuralValue: val }),

  setPossuiEmpresaValue: (val) => set({ possuiEmpresaValue: val }),

  setRendaExclusivaImage: (img) => set({ rendaExclusivaImage: img }),

  setCreditoRuralImage: (img) => set({ creditoRuralImage: img }),

  setPossuiEmpresaImage: (img) => set({ possuiEmpresaImage: img }),

  rendaPrincipalValue: null,
  dificuldadeValue: null,

  socialMapImage: null,
  rendaPrincipalImage: null,
  dificuldadeImage: null,

  setRendaPrincipalValue: (val) => set({ rendaPrincipalValue: val }),

  setDificuldadeValue: (val) => set({ dificuldadeValue: val }),

  setSocialMapImage: (img) => set({ socialMapImage: img }),

  setRendaPrincipalImage: (img) => set({ rendaPrincipalImage: img }),

  setDificuldadeImage: (img) => set({ dificuldadeImage: img }),

  empreendedorismoValue: null,
  recebeRecursosValue: null,
  atividadeRuralValue: null,

  empreendedorismoImage: null,
  recebeRecursosImage: null,
  atividadeRuralImage: null,

  setEmpreendedorismoValue: (val) => set({ empreendedorismoValue: val }),

  setRecebeRecursosValue: (val) => set({ recebeRecursosValue: val }),

  setAtividadeRuralValue: (val) => set({ atividadeRuralValue: val }),

  setEmpreendedorismoImage: (img) => set({ empreendedorismoImage: img }),

  setRecebeRecursosImage: (img) => set({ recebeRecursosImage: img }),

  setAtividadeRuralImage: (img) => set({ atividadeRuralImage: img }),

  reset: () =>
    set({
      rendaExclusivaValue: null,
      creditoRuralValue: null,
      possuiEmpresaValue: null,
      rendaPrincipalValue: null,
      dificuldadeValue: null,
      empreendedorismoValue: null,
      recebeRecursosValue: null,
      atividadeRuralValue: null,
    }),
}));
